import { render, staticRenderFns } from "./TransactionRecipientInstallments.vue?vue&type=template&id=43da363f&scoped=true"
import script from "./TransactionRecipientInstallments.vue?vue&type=script&lang=js"
export * from "./TransactionRecipientInstallments.vue?vue&type=script&lang=js"
import style0 from "./TransactionRecipientInstallments.vue?vue&type=style&index=0&id=43da363f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43da363f",
  null
  
)

export default component.exports